<mat-card [class.biggerOffset]="isDialog" [class.w-fit]="!largeAvatar" class="initialOffset w-100">
    @if (isDialog) {
        <div class="float-end">
            <button class="mat-dialog-close" mat-dialog-close mat-icon-button matTooltip="Close modal"
                    tabindex="-1">
                <mat-icon class="accent-text">close</mat-icon>
            </button>
        </div>
    }
    @if (user) {
        <mat-card-content>
            <div class="w-100 text-center">
                <div [appUserAvatar]="user" [class.p-0]="!largeAvatar" class="initial"
                     mat-card-avatar>{{ user.username | slice: 0 : 1 | titlecase }}
                </div>
                <h3 [style.--darkColor]="community?.profile_username_text_color_hex_dark"
                    [style.--lightColor]="community?.profile_username_text_color_hex"
                    class="usersName">{{ user?.username }}</h3>
                @if (user.bio) {
                    <p>{{ user.bio }}</p>
                }
            </div>
            @if ((isMe && this.hasCommunityRole(['member']) || (!isMe && this.accessLevel == 'member'))) {
                <mat-divider class="mb-15"></mat-divider>
                <div class="d-flex flex-col flex-space-around align-items-center pointsRow flex-wrap">
                    @if (community?.show_points) {
                        <div [style.color]="community?.points_earned_icon_color_hex"
                             class="bold d-flex justify-content-center">Points earned
                        </div>
                    }
                    @if (community?.show_points) {
                        <div [style.background-color]="community?.profile_points_bg_color_hex || 'var(--primary)'"
                             class="miniInitial mb-0 mx-10 p-5 mt-5">
                            <span [style.color]="community?.profile_points_color_hex ||  this.themeService.getReadableColor(community.profile_points_bg_color_hex || 'var(--theme-primary-500)')"
                                  class="font-18pt" [countUp]="user.points_in_community || userPoints || 0 "
                                  [duration]="500">{{ user.points_in_community || userPoints || 0 }}</span>
                        </div>
                    }
                    <div class="flex-col gap-10 justify-content-center mt-5">
                        <div>
                            <mat-button-toggle-group [hideSingleSelectionIndicator]="true"
                                                     (valueChange)="getUserPoints($event)" [value]="pointsDate"
                                                     aria-label="Font Style"
                                                     class="customToggleGroup smallerGroupToggle w-100">
                                <mat-button-toggle (click)="$event.stopPropagation()"
                                                   [style.background-color]="pointsDate == 'allTime'&& community?.all_time_leaderboard_filter_color_hex? community?.all_time_leaderboard_filter_color_hex: null"
                                                   value="allTime">
                                    All time
                                </mat-button-toggle>
                                <mat-button-toggle (click)="$event.stopPropagation()"
                                                   [style.background-color]="pointsDate == 'lastYear'&& community?.last_year_leaderboard_filter_color_hex? community?.last_year_leaderboard_filter_color_hex: null"
                                                   value="lastYear">
                                    Last year
                                </mat-button-toggle>
                                <mat-button-toggle (click)="$event.stopPropagation()"
                                                   [style.background-color]="pointsDate == 'month'&& community?.this_month_leaderboard_filter_color_hex? community?.this_month_leaderboard_filter_color_hex: null"
                                                   value="month">
                                    This month
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-row flex-space-around align-items-center mt-10">
                    <div [matTooltip]="'Number of comments ' + (isMe? 'you' : 'they') +' have made'"
                         class="flex-col text-center">
                        <mat-icon [style.color]="community?.user_comment_stats_color_hex" color="primary">
                            question_answer
                        </mat-icon>
                        <strong [countUp]="this.comments" [duration]="500">{{ this.comments }}</strong>
                    </div>
                    <div [matTooltip]="'Number of polls ' + (isMe? 'you' : 'they') +' have participated in'"
                         class="flex-col text-center">
                        <mat-icon [style.color]="community?.user_poll_vote_stats_color_hex" color="primary">insert_chart
                        </mat-icon>
                        <strong [countUp]="this.votes" [duration]="500">{{ this.votes }}</strong>
                    </div>
                    <div [matTooltip]="'Number of likes ' + (isMe? 'you' : 'they') +' have made'"
                         class="flex-col text-center">
                        <mat-icon [style.color]="community?.user_like_stats_color_hex" color="primary">check_box
                        </mat-icon>
                        <strong [countUp]="this.likes" [duration]="500">{{ this.likes }}</strong>
                    </div>
                </div>
                @if (community?.levels_active && this.accessLevel == 'member' && this.level) {
                    <div class="flex-row flex-space-between my-10">
                        <small>{{ level?.name }}</small>
                        @if (isMe) {
                            <small (click)="openLevels()"
                                   class="small muted clickable"
                                   matTooltip="Click for more info"
                                   role="button">More info</small>
                        }
                    </div>
                    <div class="customProgress">
                        <p [style.color]="this.themeService.getReadableColor(this.level.custom_color_hex || community?.levels_progress_slider_bg_color_hex)"
                           class="current" [countUp]=" user?.points_in_community || this.level.starting_points || 0"
                           [duration]="1000">
                            {{ user?.points_in_community || this.level.starting_points || 0 }}
                        </p>
                        <mat-progress-bar
                                [mode]="'determinate'"
                                [style.border-color]="this.level.custom_color_hex || community?.levels_progress_slider_bg_color_hex|| 'var(--theme-primary-500)'"
                                [value]="getPercent(user.points_in_community || userPoints || 0, (this.level.ending_points || 1))"
                                class="customProgress levelsBar"></mat-progress-bar>
                        @if (this.level.starting_points) {
                            <p class="required">{{ this.level.ending_points }}</p>
                        }
                    </div>
                }
                @if (!hideBadges && community?.badges_active && this.accessLevel == 'member') {
                    <div class="flex-row flex-space-between mt-10">
                        <small>
                            @if (isMe) {
                                My
                            } badges
                        </small>
                        @if (isMe) {
                            <small (click)="openBadges()" class="small clickable text-underline"
                                   matTooltip="Click for more info"
                                   role="button">View badge progress</small>
                        }
                    </div>
                }
                @if (!hideBadges && community?.badges_active && this.accessLevel == 'member') {
                    <app-badge-progress #badgeProgressComponent
                                        [limit]="4" [small]="true" [user]="user"></app-badge-progress>
                }
            }
            @if (isMe) {
                <div class="flex-row mt-10">
                    @for (streak of (streaks ?? []); track streak.id) {
                        <div class="flex-row bg-primary align-items-center justify-content-center gap-5 streakPill"
                             [matBadge]="streak.current_streak_length"
                             [matBadgeSize]="'small'" [matBadgePosition]="'before'">
                            <img [src]="streak.image" [alt]="streak.name"
                                 class="clickable" [matTooltip]="streak.description">
                            <p>{{ streak.name }}</p>
                        </div>
                    }
                </div>
            }
        </mat-card-content>
    }
</mat-card>
